<template>
    <div class="cc-availability" v-bind:class="classes">{{ availability }}</div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
            availability: function () {
                if (this.quantity > 0) {
                    return this.available_now ? this.available_now : this.translations['On stock'];
                }

                return this.available_later ? this.available_later : this.translations['Out of stock'];
            },
            classes: function () {
                const onStock = this.quantity > 0 || this.available_later;

                return {
                    'cc-availability--e-shop': onStock,
                    'cc-availability--unavailable': !onStock,
                };
            },
        },
        props: [
            'quantity',
            'available_now',
            'available_later',
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/availability";
</style>
